// ABOUTME: Renders the Settings assets page after asset data is available.
// ABOUTME: Provides the page layout for nested asset routes.
import {dataTestId} from '@hconnect/uikit'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {Outlet} from 'react-router'

import {PageLayout, SettingsSkeleton, SettingsHelmet} from '../../common/components'
import {RouteName} from '../../routing'

import {useAssetsQuery} from '@settings/modules/common/hooks'

export const PageAssetsSettings: React.FC = () => {
  const {t} = useTranslation()
  const {data: assets} = useAssetsQuery()

  if (!assets) {
    return <SettingsSkeleton numberOfDetailsCards={3} />
  }

  return (
    <PageLayout
      title={t('assetsSettings.assets')}
      {...dataTestId(`page_${RouteName.ASSETS_SETTINGS}`)}
    >
      <SettingsHelmet title={t('assetsSettings.pageTitle')} />
      <Outlet />
    </PageLayout>
  )
}
